// src/components/ThemeToggleButton.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../theme/CustomThemeProvider"; 
import { useTranslation } from "react-i18next";

const ThemeToggleButton = () => {
  const theme = useTheme();
  const { toggleColorMode } = useColorMode();
  const { t } = useTranslation();

  return (
    <Tooltip title={theme.palette.mode === "dark" ? t("light_mode") : t("dark_mode")}>
      <IconButton
        color="inherit"
        onClick={toggleColorMode}
        sx={{ ml: 1 }}
        aria-label={t("toggle_theme")}
      >
        {theme.palette.mode === "dark" ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
